import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
    // Get Vendor Categories
    getcategoriesRequest: ['payload'],
    getcategoriesSuccess: ['response'],
    getcategoriesFailure: null,

    // GET Vendor Category Popular Products
    getcategorypopularproductsRequest: ['id'],
    getcategorypopularproductsSuccess: ['response'],
    getcategorypopularproductsFailure: null,

    // GET All Vendor Category Popular Products
    getallcategorypopularproductsRequest: ['payload', 'loading'],
    getallcategorypopularproductsSuccess: ['response'],
    getallcategorypopularproductsFailure: null,

    // Get Category Products
    getcategoryproductsRequest: ['payload'],
    getcategoryproductsSuccess: ['response'],
    getcategoryproductsFailure: null,

    // Save Vendor Rating
    savevendorratingRequest: ['payload'],
    savevendorratingSuccess: ['response'],
    savevendorratingFailure: null,

    getvendorcompanyRequest: ['payload'],
    getvendorcompanySuccess: ['response'],
    getvendorcompanyFailure: null,

    // Get VR company detail
    getcompanyadminsRequest: ['payload'],
    getcompanyadminsSuccess: ['response'],
    getcompanyadminsFailure: null,

    // Get Vendor Companies
    getvendorcompaniesRequest: ['payload', 'loading'],
    getvendorcompaniesSuccess: ['response'],
    getvendorcompaniesFailure: null,

    // Get Vendor company detail
    getvrcompanydetailRequest: ['payload'],
    getvrcompanydetailSuccess: ['response'],
    getvrcompanydetailFailure: null,

    // Get Vendor Vr Catgory Mgt
    getvendorcategoriesRequest: ['payload'],
    getvendorcategoriesSuccess: ['response'],
    getvendorcategoriesFailure: null,

    // Get Vendor Vr Rating Mgt
    getvendorratingsRequest: ['payload'],
    getvendorratingsSuccess: ['response'],
    getvendorratingsFailure: null,

    // Get All Vendor Companies Info
    getallvendorcompaniesRequest: ['payload', 'loading'],
    getallvendorcompaniesSuccess: ['response'],
    getallvendorcompaniesFailure: null,

    // GET Vendor Awards
    getvendorawardsRequest: ['payload'],
    getvendorawardsSuccess: ['response'],
    getvendorawardsFailure: null,

    getrecentlyupdatedproductsRequest: ['payload'],
    getrecentlyupdatedproductsSuccess: ['response'],
    getrecentlyupdatedproductsFailure: null,

    getpopularproductsRequest: null,
    getpopularproductsSuccess: ['response'],
    getpopularproductsFailure: null,

    globalsearchRequest: ['payload', 'after', 'route', 'callback', 'target'],
    globalsearchSuccess: ['response'],
    globalsearchFailure: null,

    savevrproductRequest: ['payload'],
    savevrproductSuccess: ['response'],
    savevrproductFailure: null,

    savevrcompanyRequest: ['payload', 'callback'],
    savevrcompanySuccess: ['response'],
    savevrcompanyFailure: null,

    savevrphotoRequest: ['payload'],
    savevrphotoSuccess: ['response'],
    savevrphotoFailure: null,

    getvrcompanyRequest: ['companyId', 'payload'],
    getvrcompanySuccess: ['response'],
    getvrcompanyFailure: null,

    // Post VR company admin
    postvrcompanyadminRequest: ['payload'],
    postvrcompanyadminSuccess: ['response'],
    postvrcompanyadminFailure: null,

    // Post Blog admin
    postblogadminRequest: ['payload'],
    postblogadminSuccess: ['response'],
    postblogadminFailure: null,

    getblogRequest: ['companyId'],
    getblogSuccess: ['response'],
    getblogFailure: null,

    saveblogRequest: ['payload'],
    saveblogSuccess: ['response'],
    saveblogFailure: null,

    getblogpostsRequest: ['payload'],
    getblogpostsSuccess: ['response'],
    getblogpostsFailure: null,

    saveblogpostRequest: ['payload'],
    saveblogpostSuccess: ['response'],
    saveblogpostFailure: null,

    deleteblogpostRequest: ['payload'],
    deleteblogpostSuccess: ['response'],
    deleteblogpostFailure: null,

    postadduserRequest: ['payload'],
    postadduserSuccess: ['response'],
    postadduserFailure: null,

    postremoveuserRequest: ['payload'],
    postremoveuserSuccess: ['response'],
    postremoveuserFailure: null,

    postsaveproductRequest: ['payload', 'callback', 'after'],
    postsaveproductSuccess: ['response'],
    postsaveproductFailure: null,

    postsavecontentRequest: ['payload', 'after'],
    postsavecontentSuccess: ['response'],
    postsavecontentFailure: null,

    postsavevrmediaRequest: ['payload', 'callback'],
    postsavevrmediaSuccess: null,
    postsavevrmediaFailure: null,

    postsaveproductmediaRequest: ['payload', 'media', 'after'],
    postsaveproductmediaSuccess: ['response'],
    postsaveproductmediaFailure: null,

    postdeleteproductmediaRequest: ['payload'],
    postdeleteproductmediaSuccess: ['response'],
    postdeleteproductmediaFailure: null,

    getsuperadminbusinessRequest: ['payload'],
    getsuperadminbusinessSuccess: ['response'],
    getsuperadminbusinessFailure: null,

    getsuperadminusersRequest: ['payload'],
    getsuperadminusersSuccess: ['response'],
    getsuperadminusersFailure: null,

    getsuperadmincontentRequest: ['payload'],
    getsuperadmincontentSuccess: ['response'],
    getsuperadmincontentFailure: null,

    postsuperadminbanduserRequest: ['payload', 'after'],
    postsuperadminbanduserSuccess: ['response'],
    postsuperadminbanduserFailure: null,

    postsuperadminrestoreuserRequest: ['payload', 'after'],
    postsuperadminrestoreuserSuccess: ['response'],
    postsuperadminrestoreuserFailure: null,

    postvendorconnectRequest: ['payload', 'route', 'after', 'callback'],
    postvendorconnectSuccess: ['response'],
    postvendorconnectFailure: null,

    postcategorysaveRequest: ['payload'],
    postcategorysaveSuccess: ['response'],
    postcategorysaveFailure: null,

    postcategorydeleteRequest: ['payload', 'callback'],
    postcategorydeleteSuccess: ['response'],
    postcategorydeleteFailure: null,

    postcategoryrestoreRequest: ['payload', 'callback'],
    postcategoryrestoreSuccess: ['response'],
    postcategoryrestoreFailure: null,

    // Save Vendor Vr Rating Mgt
    postvendorratingRequest: ['payload'],
    postvendorratingSuccess: ['response'],
    postvendorratingFailure: null,

    resetRequest: null,

    // Clear all caches
    clearRequest: null,
});

export const VendorTypes = Types;
export default Creators;
